import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

// Layout Components
import Navbar from "./components/layout/navbar/navbar";
import Hero from "./components/sections/hero/Hero";
// import Stats from "./components/sections/statistics/Statistics";
import Footer from "./components/layout/footer/footer";

// Section Components
import Team from "./components/sections/team";
import ClientsPartners from "./components/sections/clients";
import ContactUs from "./components/sections/contact";
import WhyChooseUs from "./components/sections/WhyChooseUs";
import CurrentProjects from "./components/sections/projects";
import FlippingCards from "./components/sections/services";
import Products from "./components/sections/products";

function App() {
  return (
    <Router>
            <div className="text-center overflow-hidden bg-[#0F0C1F]">
        <Navbar />
        <Hero />
        {/* <Stats /> */}
        <FlippingCards />
        <Team />
        <ClientsPartners />
        <WhyChooseUs />
        <CurrentProjects />
        <Products />
        <ContactUs />
        <Footer />
      </div>
    </Router>
  );
}

export default App;